// Single source of truth for the night-mode (dark theme) toggle.
// Any component that mixes this in gets a two-way `darkMode` computed:
//   - get: reads Vuetify's current dark state
//   - set: flips Vuetify's theme AND persists the choice to localStorage (per device)
export const DARK_MODE_KEY = 'rcms_dark_mode';

export default {
    computed: {
        darkMode: {
            get() {
                return this.$vuetify.theme.dark;
            },
            set(val) {
                this.$vuetify.theme.dark = val;
                try {
                    localStorage.setItem(DARK_MODE_KEY, val ? '1' : '0');
                } catch (e) {
                    /* localStorage unavailable (private mode) — toggle still works for the session */
                }
            },
        },
    },
};
